import React from "react";

export default class CanvasErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err) {
    // optional: log for debugging
    // console.error("Canvas crashed:", err);
  }

  render() {
    if (this.state.hasError) {
      // Fail silently — keep the site usable
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
